// 기타 페이지 (NotFound, Home, MyPage 등)
const misc = {
  myPage: {
    title: '마이페이지',
    subtitle: '내 계정 정보 관리',
    editInfo: '정보 수정',
    cancel: '취소',
    save: '저장',
    joinDate: '가입일',
    lastLogin: '마지막 로그인',
    basicInfo: '기본 정보',
    name: '이름',
    email: '이메일',
    phone: '연락처',
    department: '부서',
    role: '역할',
    changePassword: '비밀번호 변경',
    currentPassword: '현재 비밀번호',
    currentPasswordPlaceholder: '현재 비밀번호 입력',
    newPassword: '새 비밀번호',
    newPasswordPlaceholder: '새 비밀번호 입력 (8자 이상)',
    confirmPassword: '새 비밀번호 확인',
    confirmPasswordPlaceholder: '새 비밀번호 재입력',
    submitPassword: '비밀번호 변경',
    passwordMismatch: '새 비밀번호가 일치하지 않습니다.',
    passwordChanged: '비밀번호가 변경되었습니다.',
    defaultName: '김관리',
    defaultRole: '시스템 관리자',
    defaultDepartment: 'IT팀',
  },
  notFound: {
    title: '페이지를 찾을 수 없습니다',
    message: '요청하신 페이지가 존재하지 않거나 이동되었습니다.',
    goBack: '이전 페이지',
    goHome: '홈으로',
  },
  modelDashboard: {
    title: '모델 성능 대시보드',
    subtitle: '학습된 이상탐지 모델 현황 및 성능 분석',
    summaryBtn: '성능요약',
    refresh: '새로고침',
    gpuLive: 'GPU Live',
    mockData: 'Mock Data',
    errorPrefix: 'GPU 서버 연결 실패: {error}',
    loading: '데이터 로딩 중...',
    historyLoading: '학습 히스토리 로딩 중...',
    noHistory: '학습 히스토리가 없습니다',
    kpi: {
      lstm: 'LSTM 모델',
      ae: 'AE 모델',
      total: '전체 모델',
      totalData: '총 사용 데이터',
      unitCount: '개',
      unitRecords: '건',
    },
    table: {
      modelId: '모델 ID',
      equipment: '설비',
      mold: '금형',
      valLoss: 'Val Loss',
      accuracy: '정확도',
      precision: 'Precision',
      recall: 'Recall',
      f1: 'F1',
      fpr: 'FPR',
      dataCount: '데이터 수',
      trainedAt: '학습일',
      empty: '학습된 모델이 없습니다',
    },
    detail: {
      confusionMatrix: '혼동행렬 (Confusion Matrix)',
      predNormal: '예측: 정상',
      predAnomaly: '예측: 이상',
      actualNormal: '실제: 정상',
      actualAnomaly: '실제: 이상',
      tn: 'TN',
      fp: 'FP (오탐)',
      fn: 'FN (미탐)',
      tp: 'TP',
      validSample: '검증 샘플',
      validSampleSuffix: '{n}건',
      accuracyLabel: '정확도',
      fprLabel: '오탐률 (FPR)',
      trainThreshold: 'Train Threshold',
      valThreshold: 'Val Threshold',
      cmNote: '* Ground Truth: Val 95th percentile 기준 | Prediction: Train 95th percentile 기준',
      trainingCurve: '학습 곡선',
      totalEpoch: '총 {n} Epoch',
      convergence: '수렴: {n} Epoch',
      finalValLoss: '최종 Val Loss: {n}',
      reduction: '감소율: {n}%',
    },
    summary: {
      title: '이상탐지 모델 성능 요약',
      subtitle: 'Smart Injection Monitoring - AI Model Performance Report',
      totalModels: '전체 모델 수',
      totalData: '총 학습 데이터',
      lstmCount: 'LSTM 모델',
      aeCount: 'AE 모델',
      modelCount: '{n}개 모델',
      avgAccuracy: '평균 정확도 (Accuracy)',
      avgPrecision: '평균 정밀도 (Precision)',
      avgRecall: '평균 재현율 (Recall)',
      avgF1: '평균 F1 Score',
      trainData: '학습 데이터',
      retrainNeeded: '재학습 필요',
      footerNote: 'Confusion Matrix 기준: Ground Truth = Val 95th Percentile, Prediction = Train 95th Percentile Threshold',
      unitCount: '개',
      unitRecords: '건',
    },
  },
};

export default misc;
